import { RootState } from "../store";

export const subscriptionsSelector = (state: RootState) => state.subscriptions;
